import useHistory from 'app/modules/tailor/hooks/useHistory';
import { usePersistedLocation } from 'app/modules/tailor/hooks/usePersistedLocation';
import { useEffect } from 'react';

import useLandingRoute from './useLandingRoute';

export default function useInitialLocation() {
  const [persistedLocation, , removePersistedLocation] = usePersistedLocation();
  const { entries } = useHistory();
  const landingRoute = useLandingRoute();
  const searchParams = new URLSearchParams(window.location.search);
  const tailorUrl = searchParams.get('tailorUrl');
  const initialEntries =
    tailorUrl && !tailorUrl?.startsWith('/contact-form')
      ? [landingRoute, tailorUrl]
      : persistedLocation
        ? entries
        : [landingRoute];

  const initialIndex = tailorUrl ? 1 : persistedLocation ? entries.length - 1 : 0;

  useEffect(() => {
    if (persistedLocation) {
      removePersistedLocation();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { initialEntries, initialIndex, tailorUrl };
}
